import { createSelector } from 'reselect';
import getCurrentUser from './getCurrentUser';

const getIsNewUser = createSelector(getCurrentUser, user => {
  if (!user) return true;

  // The order of checks is important. We prioritize order counts over the `isNew`
  // property as they are considered more reliable indicators of a new user.
  if (user.data?.orderCount !== undefined) return user.data?.orderCount === 0;

  if (user.userTrustScore?.confirmedOnlineOrderCount !== undefined)
    return user.userTrustScore?.confirmedOnlineOrderCount === 0;

  if (user.isNew !== undefined) return Boolean(user.isNew);

  if (user.firstOrderDate !== undefined) return !user.firstOrderDate;

  return false;
});

export default getIsNewUser;
